import { Duration } from 'luxon';

/**
 * Hours per year (365 days * 24 hours).
 * Note that this doesn't account for leap years.
 */
export const HOURS_PER_YEAR = Duration.fromObject({ days: 365 }).as('hours');
